import { render } from "./Schoolyears.vue?vue&type=template&id=23296004"
import script from "./Schoolyears.vue?vue&type=script&lang=js"
export * from "./Schoolyears.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arkane/Dev/Projects/Web/ecole-alpha.proj/ecole-alpha.2025-2026.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.3.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__